import React from "react";

/**
 * Reusable phone mockup.
 * To use a real screenshot: pass `src` (and `alt`). The placeholder shows otherwise.
 *
 * props:
 *  - variant: "center" | "left" | "right" | "feature" | "pitch" | "plain"
 *  - label:   placeholder caption (e.g. "Home")
 *  - src:     image url (optional) — when set, the image renders instead of placeholder
 *  - alt:     image alt text
 *  - notch:   show the top notch (default true for center/feature/pitch)
 */
export default function Phone({ variant = "plain", label = "Screen", src, alt, notch }) {
  const cls =
    variant === "center"
      ? "phone p-center"
      : variant === "left"
      ? "phone p-side p-left"
      : variant === "right"
      ? "phone p-side p-right"
      : variant === "feature"
      ? "feat-phone"
      : variant === "pitch"
      ? "pitch-phone"
      : "phone";

  const showNotch =
    notch ?? (variant === "center" || variant === "feature" || variant === "pitch");

  return (
    <div className={cls}>
      {showNotch && <div className="notch" />}
      <div className="scr">
        {src ? (
          <img src={src} alt={alt || label} />
        ) : (
          <div className="ph-fill">
            <span className="ph-if">if</span>
            {label}
            <br />
            <span style={{ opacity: 0.6 }}>replace image</span>
          </div>
        )}
      </div>
    </div>
  );
}
